import { WordTreeNoRepBuilder } from "../../General/Tree/wordTree/word-tree-no-rep-builder";
import { TreeNode } from "../../General/Tree/lib/tree-node";

export class AllWordsNoRep extends WordTreeNoRepBuilder {
       
    protected hideMode: boolean = false;

    leftClickTreeNode(treeNode: TreeNode) {
        if (this.hideMode) {
            let hide: boolean = !treeNode.isHidden();
            treeNode.setHidden(hide);
            this.hideMode = false;
        }

        this.canvas.style.cursor = 'default';

    }

    selectHideMode(mode:boolean) {
        this.hideMode = mode;
    }
 
    getHideMode():boolean{
       return this.hideMode;
    }
}
